import React from 'react'

const TeamBlog = () => {
  return (
    <div className='site-info'>Site under construction...</div>
  )
}

export default TeamBlog